import ActionTypeContrato from "../ActionTypeContrato";
import { TipoItem, Udm} from "../../../../isp.žapi.contratos/constantesApiContratos";

// import {ModosOp} from '../../../../_comun/reductores/Constantes'

export default class CargaDeContratoConsultado extends ActionTypeContrato {

    ejecutar(estado, nuevoEstado) {
        // nuevoEstado.domain.idCliente = this.payload.idCliente;
        // nuevoEstado.domain.fechaReg = this.payload.fechaReg;
        // nuevoEstado.domain.estado = this.payload.estado;
        // nuevoEstado.flag.procesandoComando = false;
        // nuevoEstado.flag.modoOperacion = ModosOp.OK;
        // Estado.Registrado = estado.domain;
        // Estado.ParaUpdate={};
        nuevoEstado.flag.modal = false;
        nuevoEstado.flag.cargandoEntidad = false;
        nuevoEstado.domain.screen = {...estado.domain.screen, ...this.payload};
        nuevoEstado.domain.screen.combos.tiposItem=[nuevoEstado.domain.screen.tipoItem]
        if (this.payload.tipoItem === TipoItem.ContratosGen || this.payload.tipoItem === TipoItem.Articulo) {
            // nuevoEstado.domain.screen.udm=Udm.Unidad;
            
            nuevoEstado.domain.screen.combos.udms=[Udm.Unidad];
        }
        if (this.payload.tipoItem === TipoItem.PlanInternet) {
            // nuevoEstado.domain.screen.udm=Udm.Mensual;
            // nuevoEstado.domain.screen.combos.tiposItem=[nuevoEstado.domain.screen.tipoItem]
            nuevoEstado.domain.screen.combos.udms=[Udm.Mensual];
        }

        nuevoEstado.domain.cargado = JSON.parse(JSON.stringify(this.payload));
        nuevoEstado.domain.update = {}
        nuevoEstado.domain.nroUpdates= 0;

        return nuevoEstado;
    }

}